module.exports = __webpack_public_path__ + "images/29ef9b489e46cc9e013f25269daaa561.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/close_black@2x.png
// module id = 586
// module chunks = 24